module.exports = __webpack_public_path__ + "assets/img/00114.ca083b31.png";